import React from "react";
import "./Loading.css";

const Loading = ({ size = "medium", fullPage = false }) => {
  return (
    <div className={`loading-wrapper ${fullPage ? "loading-fullpage" : ""}`}>
      <div className={`loading-spinner loading-${size}`}>
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default Loading;
